/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Integrations_Gbp_AccountInputs */

const cs_integrations_gbp_account = /** @type {(inputs: Integrations_Gbp_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Účet`)
};

const en_integrations_gbp_account = /** @type {(inputs: Integrations_Gbp_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Account`)
};

/**
* | output |
* | --- |
* | "Account" |
*
* @param {Integrations_Gbp_AccountInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const integrations_gbp_account = /** @type {((inputs?: Integrations_Gbp_AccountInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Integrations_Gbp_AccountInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_integrations_gbp_account(inputs)
	return cs_integrations_gbp_account(inputs)
});